!function(e) {
    "use strict";
    let t = (e, t) => {
        if (!e)
            return t;
        if ("number" == typeof e)
            return e;
        let i = e.replaceAll("px", "").replaceAll("%", "").replaceAll("rem", "").replaceAll("em", "");
        return isNaN(Number(i)) ? t : Number(i)
    }
      , i = (e, t, i) => {
        var l, r, n, a, o, s;
        switch (t) {
        case "tablet":
            return null !== (r = null !== (l = null == e ? void 0 : e.tablet) && void 0 !== l ? l : null == e ? void 0 : e.desktop) && void 0 !== r ? r : i;
        case "mobile":
            return null !== (o = null !== (a = null !== (n = null == e ? void 0 : e.mobile) && void 0 !== n ? n : null == e ? void 0 : e.tablet) && void 0 !== a ? a : null == e ? void 0 : e.desktop) && void 0 !== o ? o : i;
        default:
            return null !== (s = null == e ? void 0 : e.desktop) && void 0 !== s ? s : i
        }
    }
      , l = (e, t) => ({
        [`--${e}`]: null == t ? void 0 : t.desktop,
        [`--${e}-tablet`]: null == t ? void 0 : t.tablet,
        [`--${e}-mobile`]: null == t ? void 0 : t.mobile
    })
      , r = (e, t) => {
        let i = (e, t, i) => {
            let l = null == t ? void 0 : t[e]
              , r = null == i ? void 0 : i[e];
            return r ? "100%" : l
        }
        ;
        return {
            desktop: i("desktop", e, t),
            tablet: i("tablet", e, t),
            mobile: i("mobile", e, t)
        }
    }
      , n = ["desktop", "tablet", "mobile"]
      , a = (e, t) => {
        let l = {};
        return n.forEach(r => {
            let n = i(t, r);
            switch (n) {
            case "bottom-center":
            case "bottom-left":
                l = {
                    ...l,
                    [r]: i(e.shapeForBottom, r)
                };
                break;
            case "left":
            case "right":
                l = {
                    ...l,
                    [r]: i(e.shape, r)
                };
                break;
            case "only-feature":
                l = {
                    ...l,
                    [r]: i(e.shapeForFtOnly, r)
                };
                break;
            case "one-col":
                l = {
                    ...l,
                    [r]: i(e.shapeFor1Col, r)
                };
                break;
            case "two-col":
                l = {
                    ...l,
                    [r]: i(e.shapeFor2Col, r)
                }
            }
        }
        ),
        l
    }
    ;
    var o, s, d, u, c, h, g, v, p, m, f, y, I, E, b = function() {
        return (b = Object.assign || function(e) {
            for (var t, i = 1, l = arguments.length; i < l; i++)
                for (var r in t = arguments[i])
                    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            return e
        }
        ).apply(this, arguments)
    };
    function S(e, t, i) {
        for (var l, r = 0, n = t.length; r < n; r++)
            !l && r in t || (l || (l = Array.prototype.slice.call(t, 0, r)),
            l[r] = t[r]);
        return e.concat(l || Array.prototype.slice.call(t))
    }
    function w(e) {
        return Array.prototype.slice.call(e)
    }
    function C(e, t) {
        var i = Math.floor(e);
        return i === t || i + 1 === t ? e : t
    }
    function x() {
        return Date.now()
    }
    function A(e, t, i) {
        if (t = "data-keen-slider-" + t,
        null === i)
            return e.removeAttribute(t);
        e.setAttribute(t, i || "")
    }
    function L(e, t) {
        return t = t || document,
        "function" == typeof e && (e = e(t)),
        Array.isArray(e) ? e : "string" == typeof e ? w(t.querySelectorAll(e)) : e instanceof HTMLElement ? [e] : e instanceof NodeList ? w(e) : []
    }
    function F(e) {
        e.raw && (e = e.raw),
        e.cancelable && !e.defaultPrevented && e.preventDefault()
    }
    function T(e) {
        e.raw && (e = e.raw),
        e.stopPropagation && e.stopPropagation()
    }
    function k() {
        var e = [];
        return {
            add: function(t, i, l, r) {
                t.addListener ? t.addListener(l) : t.addEventListener(i, l, r),
                e.push([t, i, l, r])
            },
            input: function(e, t, i, l) {
                this.add(e, t, function(e) {
                    e.nativeEvent && (e = e.nativeEvent);
                    var t = e.changedTouches || []
                      , l = e.targetTouches || []
                      , r = e.detail && e.detail.x ? e.detail : null;
                    return i({
                        id: r ? r.identifier ? r.identifier : "i" : l[0] ? l[0] ? l[0].identifier : "e" : "d",
                        idChanged: r ? r.identifier ? r.identifier : "i" : t[0] ? t[0] ? t[0].identifier : "e" : "d",
                        raw: e,
                        x: r && r.x ? r.x : l[0] ? l[0].screenX : r ? r.x : e.pageX,
                        y: r && r.y ? r.y : l[0] ? l[0].screenY : r ? r.y : e.pageY
                    })
                }, l)
            },
            purge: function() {
                e.forEach(function(e) {
                    e[0].removeListener ? e[0].removeListener(e[2]) : e[0].removeEventListener(e[1], e[2], e[3])
                }),
                e = []
            }
        }
    }
    function _(e, t, i) {
        return Math.min(Math.max(e, t), i)
    }
    function G(e) {
        return (e > 0 ? 1 : 0) - (e < 0 ? 1 : 0) || +e
    }
    function $(e) {
        var t = e.getBoundingClientRect();
        return {
            height: C(t.height, e.offsetHeight),
            width: C(t.width, e.offsetWidth)
        }
    }
    function M(e, t, i, l) {
        var r = e && e[t];
        return null == r ? i : l && "function" == typeof r ? r() : r
    }
    function O(e) {
        return Math.round(1e6 * e) / 1e6
    }
    function R(e) {
        var t, i, l, r, n, a, o, s;
        function d(e) {
            return 1 - Math.pow(1 - e, 3)
        }
        function u() {
            return l ? e.track.velocity() : 0
        }
        function c(e, t) {
            void 0 === t && (t = 1e3);
            var i = 147e-9 + (e = Math.abs(e)) / t;
            return {
                dist: Math.pow(e, 2) / i,
                dur: e / i
            }
        }
        function h() {
            var t = e.track.details;
            t && (n = t.min,
            a = t.max,
            o = t.minIdx,
            s = t.maxIdx)
        }
        function g() {
            e.animator.stop()
        }
        e.on("updated", h),
        e.on("optionsChanged", h),
        e.on("created", h),
        e.on("dragStarted", function() {
            l = !1,
            g(),
            t = i = e.track.details.abs
        }),
        e.on("dragChecked", function() {
            l = !0
        }),
        e.on("dragEnded", function() {
            var l, h, v, p, m, f, y = e.options.mode;
            "snap" === y && (l = e.track,
            v = (h = e.track.details).position,
            p = G(u()),
            (v > a || v < n) && (p = 0),
            m = t + p,
            0 === h.slides[l.absToRel(m)].portion && (m -= p),
            t !== i && (m = i),
            G(l.idxToDist(m, !0)) !== p && (m += p),
            m = _(m, o, s),
            f = l.idxToDist(m, !0),
            e.animator.start([{
                distance: f,
                duration: 500,
                easing: function(e) {
                    return 1 + --e * e * e * e * e
                }
            }])),
            "free" !== y && "free-snap" !== y || function() {
                g();
                var t = "free-snap" === e.options.mode
                  , i = e.track
                  , l = u();
                r = G(l);
                var h = e.track.details
                  , v = [];
                if (l || !t) {
                    var p = c(l)
                      , m = p.dist
                      , f = p.dur;
                    if (f *= 2,
                    m *= r,
                    t) {
                        var y = i.idxToDist(i.distToIdx(m), !0);
                        y && (m = y)
                    }
                    v.push({
                        distance: m,
                        duration: f,
                        easing: d
                    });
                    var I = h.position
                      , E = I + m;
                    if (E < n || E > a) {
                        var b = E < n ? n - I : a - I
                          , S = 0
                          , w = l;
                        if (G(b) === r) {
                            var C = Math.min(Math.abs(b) / Math.abs(m), 1)
                              , x = (1 - Math.pow(1 - C, 1 / 3)) * f;
                            v[0].earlyExit = x,
                            w = l * (1 - C)
                        } else
                            v[0].earlyExit = 0,
                            S += b;
                        var A = c(w, 100)
                          , L = A.dist * r;
                        e.options.rubberband && (v.push({
                            distance: L,
                            duration: 2 * A.dur,
                            easing: d
                        }),
                        v.push({
                            distance: -L + S,
                            duration: 500,
                            easing: d
                        }))
                    }
                    e.animator.start(v)
                } else
                    e.moveToIdx(_(h.abs, o, s), !0, {
                        duration: 500,
                        easing: function(e) {
                            return 1 + --e * e * e * e * e
                        }
                    })
            }()
        }),
        e.on("dragged", function() {
            i = e.track.details.abs
        })
    }
    function z(e) {
        var t, i, l, r, n, a, o, s, d, u, c, h, g, v, p, m, f, y, I = k();
        function E(t) {
            if (a && s === t.id) {
                var g = C(t);
                if (d) {
                    if (!w(t))
                        return S(t);
                    u = g,
                    d = !1,
                    e.emit("dragChecked")
                }
                if (m)
                    return u = g;
                F(t);
                var v = function(t) {
                    if (f === -1 / 0 && y === 1 / 0)
                        return t;
                    var l = e.track.details
                      , a = l.length
                      , o = l.position
                      , s = _(t, f - o, y - o);
                    if (0 === a)
                        return 0;
                    if (!e.options.rubberband)
                        return s;
                    if (o <= y && o >= f || o < f && i > 0 || o > y && i < 0)
                        return t;
                    var d = Math.max(0, 1 - Math.abs((o < f ? o - f : o - y) / a * (r * a)) / n * 2);
                    return d * d * t
                }(o(u - g) / r * l);
                i = G(v);
                var p = e.track.details.position;
                (p > f && p < y || p === f && i > 0 || p === y && i < 0) && T(t),
                c += v,
                !h && Math.abs(c * r) > 5 && (h = !0),
                e.track.add(v),
                u = g,
                e.emit("dragged")
            }
        }
        function b(t) {
            !a && e.track.details && e.track.details.length && (c = 0,
            a = !0,
            h = !1,
            d = !0,
            s = t.id,
            w(t),
            u = C(t),
            e.emit("dragStarted"))
        }
        function S(t) {
            a && s === t.idChanged && (a = !1,
            e.emit("dragEnded"))
        }
        function w(e) {
            var t = x()
              , i = t ? e.y : e.x
              , l = t ? e.x : e.y
              , r = void 0 !== g && void 0 !== v && Math.abs(v - l) <= Math.abs(g - i);
            return g = i,
            v = l,
            r
        }
        function C(e) {
            return x() ? e.y : e.x
        }
        function x() {
            return e.options.vertical
        }
        function A() {
            r = e.size,
            n = x() ? window.innerHeight : window.innerWidth;
            var t = e.track.details;
            t && (f = t.min,
            y = t.max)
        }
        function $(e) {
            h && (T(e),
            F(e))
        }
        function M() {
            if (I.purge(),
            e.options.drag && !e.options.disabled) {
                o = "function" == typeof (r = e.options.dragSpeed || 1) ? r : function(e) {
                    return e * r
                }
                ,
                l = e.options.rtl ? -1 : 1,
                A(),
                t = e.container,
                i = "data-keen-slider-clickable",
                L("[".concat(i, "]:not([").concat(i, "=false])"), t).map(function(e) {
                    I.add(e, "dragstart", T),
                    I.add(e, "mousedown", T),
                    I.add(e, "touchstart", T)
                }),
                I.add(t, "dragstart", function(e) {
                    F(e)
                }),
                I.add(t, "click", $, {
                    capture: !0
                }),
                I.input(t, "ksDragStart", b),
                I.input(t, "ksDrag", E),
                I.input(t, "ksDragEnd", S),
                I.input(t, "mousedown", b),
                I.input(t, "mousemove", E),
                I.input(t, "mouseleave", S),
                I.input(t, "mouseup", S),
                I.input(t, "touchstart", b, {
                    passive: !0
                }),
                I.input(t, "touchmove", E, {
                    passive: !1
                }),
                I.input(t, "touchend", S),
                I.input(t, "touchcancel", S),
                I.add(window, "wheel", function(e) {
                    a && F(e)
                });
                var i, r, n = "data-keen-slider-scrollable";
                L("[".concat(n, "]:not([").concat(n, "=false])"), e.container).map(function(e) {
                    var t;
                    I.input(e, "touchstart", function(e) {
                        t = C(e),
                        m = !0,
                        p = !0
                    }, {
                        passive: !0
                    }),
                    I.input(e, "touchmove", function(i) {
                        var l = x()
                          , r = l ? e.scrollHeight - e.clientHeight : e.scrollWidth - e.clientWidth
                          , n = t - C(i)
                          , a = l ? e.scrollTop : e.scrollLeft
                          , o = l && "scroll" === e.style.overflowY || !l && "scroll" === e.style.overflowX;
                        if (t = C(i),
                        (n < 0 && a > 0 || n > 0 && a < r) && p && o)
                            return m = !0;
                        p = !1,
                        F(i),
                        m = !1
                    }),
                    I.input(e, "touchend", function() {
                        m = !1
                    })
                })
            }
        }
        e.on("updated", A),
        e.on("optionsChanged", M),
        e.on("created", M),
        e.on("destroyed", I.purge)
    }
    function P(e) {
        var t, i, l = null;
        function r(t, i, l) {
            e.animator.active ? a(t, i, l) : requestAnimationFrame(function() {
                return a(t, i, l)
            })
        }
        function n() {
            r(!1, !1, i)
        }
        function a(i, r, n) {
            var a = 0
              , o = e.size
              , u = e.track.details;
            if (u && t) {
                var c = u.slides;
                t.forEach(function(e, t) {
                    if (i)
                        !l && r && s(e, null, n),
                        d(e, null, n);
                    else {
                        if (!c[t])
                            return;
                        var u = c[t].size * o;
                        !l && r && s(e, u, n),
                        d(e, c[t].distance * o - a, n),
                        a += u
                    }
                })
            }
        }
        function o(t) {
            return "performance" === e.options.renderMode ? Math.round(t) : t
        }
        function s(e, t, i) {
            var l = i ? "height" : "width";
            null !== t && (t = o(t) + "px"),
            e.style["min-" + l] = t,
            e.style["max-" + l] = t
        }
        function d(e, t, i) {
            if (null !== t) {
                t = o(t);
                var l = i ? t : 0;
                t = "translate3d(".concat(i ? 0 : t, "px, ").concat(l, "px, 0)")
            }
            e.style.transform = t,
            e.style["-webkit-transform"] = t
        }
        function u() {
            t && (a(!0, !0, i),
            t = null),
            e.on("detailsChanged", n, !0)
        }
        function c() {
            r(!1, !0, i)
        }
        function h() {
            u(),
            i = e.options.vertical,
            e.options.disabled || "custom" === e.options.renderMode || (l = "auto" === M(e.options.slides, "perView", null),
            e.on("detailsChanged", n),
            (t = e.slides).length && c())
        }
        e.on("created", h),
        e.on("optionsChanged", h),
        e.on("beforeOptionsChanged", function() {
            u()
        }),
        e.on("updated", c),
        e.on("destroyed", u)
    }
    "function" == typeof SuppressedError && SuppressedError;
    var V = function(e, t, i) {
        try {
            var l, r, n, a;
            return r = S([(l = {
                drag: !0,
                mode: "snap",
                renderMode: "precision",
                rubberband: !0,
                selector: ".keen-slider__slide"
            },
            function(t) {
                var i, r, n, a, o, s = k();
                function d(e) {
                    var i;
                    A(t.container, "reverse", "rtl" !== (i = t.container,
                    window.getComputedStyle(i, null).getPropertyValue("direction")) || e ? null : ""),
                    A(t.container, "v", t.options.vertical && !e ? "" : null),
                    A(t.container, "disabled", t.options.disabled && !e ? "" : null)
                }
                function u() {
                    c() && p()
                }
                function c() {
                    var e = null;
                    if (a.forEach(function(t) {
                        t.matches && (e = t.__media)
                    }),
                    e === i)
                        return !1;
                    i || t.emit("beforeOptionsChanged"),
                    i = e;
                    var l = e ? n.breakpoints[e] : n;
                    return t.options = b(b({}, n), l),
                    d(),
                    E(),
                    S(),
                    f(),
                    !0
                }
                function h() {
                    return t.options.trackConfig.length
                }
                function g(e) {
                    for (var o in i = !1,
                    n = b(b({}, l), e),
                    s.purge(),
                    r = t.size,
                    a = [],
                    n.breakpoints || []) {
                        var d = window.matchMedia(o);
                        d.__media = o,
                        a.push(d),
                        s.add(d, "change", u)
                    }
                    s.add(window, "orientationchange", I),
                    s.add(window, "resize", y),
                    c()
                }
                function v(e) {
                    t.animator.stop();
                    var i = t.track.details;
                    t.track.init(null != e ? e : i ? i.abs : 0)
                }
                function p(e) {
                    v(e),
                    t.emit("optionsChanged")
                }
                function m(e, i) {
                    if (e)
                        return g(e),
                        void p(i);
                    E(),
                    S();
                    var l = h();
                    f(),
                    h() !== l ? p(i) : v(i),
                    t.emit("updated")
                }
                function f() {
                    var e = t.options.slides;
                    if ("function" == typeof e)
                        return t.options.trackConfig = e(t.size, t.slides);
                    var i = t.slides
                      , l = i.length
                      , r = "number" == typeof e ? e : M(e, "number", l, !0)
                      , n = []
                      , a = M(e, "perView", 1, !0)
                      , o = "number" == typeof a ? M(e, "numberOfFullWidthShow", void 0, !0) : a
                      , s = M(e, "spacing", 0, !0) / t.size || 0
                      , d = "auto" === a ? s : s / a
                      , u = 0;
                    "number" == typeof o && (u = s * (Math.floor(o) - 1));
                    for (var c = M(e, "origin", "auto"), h = 0, g = 0; g < r; g++) {
                        var v = "auto" === a ? function(e) {
                            var i = $(e);
                            return (t.options.vertical ? i.height : i.width) / t.size || 1
                        }(i[g]) - s + d : 1 / a - s + d
                          , p = "center" === c ? "number" == typeof o ? .5 - u / 2 - Math.floor(o) * v / 2 : .5 - v / 2 : "auto" === c ? 0 : c;
                        n.push({
                            origin: p,
                            size: v,
                            spacing: s
                        }),
                        h += v
                    }
                    if (h += s * (r - 1),
                    "auto" === c && !t.options.loop && 1 !== a) {
                        var m = 0;
                        n.map(function(e) {
                            var t = h - m;
                            return m += e.size + s,
                            t >= 1 || (e.origin = 1 - t - (h > 1 ? 0 : 1 - h)),
                            e
                        })
                    }
                    t.options.trackConfig = n
                }
                function y() {
                    E();
                    var e = t.size;
                    t.options.disabled || e === r || (r = e,
                    m())
                }
                function I() {
                    y(),
                    setTimeout(y, 500),
                    setTimeout(y, 2e3)
                }
                function E() {
                    var e = $(t.container);
                    t.size = (t.options.vertical ? e.height : e.width) || 1
                }
                function S() {
                    t.slides = L(t.options.selector, t.container)
                }
                t.container = (o = L(e, document)).length ? o[0] : null,
                t.destroy = function() {
                    s.purge(),
                    t.emit("destroyed"),
                    d(!0)
                }
                ,
                t.prev = function() {
                    t.moveToIdx(t.track.details.abs - 1, !0)
                }
                ,
                t.next = function() {
                    t.moveToIdx(t.track.details.abs + 1, !0)
                }
                ,
                t.update = m,
                g(t.options)
            }
            ), P, z, R], i || [], !0),
            a = {},
            n = {
                emit: function(e) {
                    a[e] && a[e].forEach(function(e) {
                        e(n)
                    });
                    var t = n.options && n.options[e];
                    t && t(n)
                },
                moveToIdx: function(e, t, i) {
                    var l = n.track.idxToDist(e, t);
                    if (l) {
                        var r = n.options.defaultAnimation;
                        n.animator.start([{
                            distance: l,
                            duration: M(i || r, "duration", 500),
                            easing: M(i || r, "easing", function(e) {
                                return 1 + --e * e * e * e * e
                            })
                        }])
                    }
                },
                on: function(e, t, i) {
                    void 0 === i && (i = !1),
                    a[e] || (a[e] = []);
                    var l = a[e].indexOf(t);
                    l > -1 ? i && delete a[e][l] : i || a[e].push(t)
                },
                options: t
            },
            function() {
                if (n.track = function(e) {
                    var t, i, l, r, n, a, o, s, d, u, c, h, g, v, p = 1 / 0, m = [], f = null, y = 0;
                    function I(e) {
                        F(y + e)
                    }
                    function E(e) {
                        var t = b(y + e).abs;
                        return A(t) === t ? t : null
                    }
                    function b(e) {
                        var t = Math.floor(Math.abs(O(e / i)))
                          , l = O((e % i + i) % i);
                        l === i && (l = 0);
                        var r = G(e)
                          , n = o.indexOf(S([], o).reduce(function(e, t) {
                            return Math.abs(t - l) < Math.abs(e - l) ? t : e
                        }))
                          , s = n;
                        return r < 0 && t++,
                        n === a && (s = 0,
                        t += r > 0 ? 1 : -1),
                        {
                            abs: s + t * a * r,
                            origin: n,
                            rel: s
                        }
                    }
                    function w(e, t, i) {
                        if (t || !r.loop)
                            return C(e, i);
                        if (A(e) !== e)
                            return null;
                        var l, n = b(null != i ? i : y), o = n.abs, s = e - n.rel, d = o + s;
                        l = C(d);
                        var u = C(d - a * G(s));
                        return (null !== u && Math.abs(u) < Math.abs(l) || null === l) && (l = u),
                        O(l)
                    }
                    function C(e, t) {
                        if (null == t && (t = O(y)),
                        l = e,
                        A(l) !== l || null === e)
                            return null;
                        e = Math.round(e);
                        var l, r = b(t), n = r.abs, s = r.rel, d = r.origin, u = L(e), c = (t % i + i) % i, h = o[d], g = Math.floor((e - (n - s)) / a) * i;
                        return O(h - c - h + o[u] + g + (d === a ? i : 0))
                    }
                    function A(e) {
                        return _(e, d, u)
                    }
                    function L(e) {
                        return (e % a + a) % a
                    }
                    function F(t) {
                        i = t - y,
                        m.push({
                            distance: i,
                            timestamp: x()
                        }),
                        m.length > 6 && (m = m.slice(-6)),
                        y = O(t);
                        var i, l = T().abs;
                        if (l !== f) {
                            var r = null !== f;
                            f = l,
                            r && e.emit("slideChanged")
                        }
                    }
                    function T(o) {
                        var s = o ? null : function() {
                            if (a) {
                                var e = r.loop
                                  , t = e ? (y % i + i) % i : y
                                  , o = (e ? y % i : y) - n[0][2]
                                  , s = 0 - (o < 0 && e ? i - Math.abs(o) : o)
                                  , p = 0
                                  , m = b(y)
                                  , f = m.abs
                                  , I = m.rel
                                  , E = n[I][2]
                                  , S = n.map(function(t, l) {
                                    var n = s + p;
                                    (n < 0 - t[0] || n > 1) && (n += (Math.abs(n) > i - 1 && e ? i : 0) * G(-n));
                                    var o = l - I
                                      , d = G(o)
                                      , u = o + f;
                                    e && (-1 === d && n > E && (u += a),
                                    1 === d && n < E && (u -= a),
                                    null !== c && u < c && (n += i),
                                    null !== h && u > h && (n -= i));
                                    var g = n + t[0] + t[1]
                                      , v = Math.max(n >= 0 && g <= 1 ? 1 : g < 0 || n > 1 ? 0 : n < 0 ? Math.min(1, (t[0] + n) / t[0]) : (1 - n) / t[0], 0);
                                    return p += t[0] + t[1],
                                    {
                                        abs: u,
                                        distance: r.rtl ? -1 * n + 1 - t[0] : n,
                                        portion: v,
                                        size: t[0]
                                    }
                                });
                                return I = L(f = A(f)),
                                {
                                    abs: A(f),
                                    length: l,
                                    max: v,
                                    maxIdx: u,
                                    min: g,
                                    minIdx: d,
                                    position: y,
                                    progress: e ? t / i : y / l,
                                    rel: I,
                                    slides: S,
                                    slidesLength: i
                                }
                            }
                        }();
                        return t.details = s,
                        e.emit("detailsChanged"),
                        s
                    }
                    return t = {
                        absToRel: L,
                        add: I,
                        details: null,
                        distToIdx: E,
                        idxToDist: w,
                        init: function(t) {
                            var m, f, b, S;
                            if (function() {
                                if (a = (n = ((r = e.options).trackConfig || []).map(function(e) {
                                    return [M(e, "size", 1), M(e, "spacing", 0), M(e, "origin", 0)]
                                })).length) {
                                    i = O(n.reduce(function(e, t) {
                                        return e + t[0] + t[1]
                                    }, 0));
                                    var t, d = a - 1;
                                    l = O(i + n[0][2] - n[d][0] - n[d][2] - n[d][1]),
                                    o = n.reduce(function(e, i) {
                                        if (!e)
                                            return [0];
                                        var l = n[e.length - 1]
                                          , r = e[e.length - 1] + (l[0] + l[2]) + l[1];
                                        return r -= i[2],
                                        e[e.length - 1] > r && (r = e[e.length - 1]),
                                        r = O(r),
                                        e.push(r),
                                        (!t || t < r) && (s = e.length - 1),
                                        t = r,
                                        e
                                    }, null),
                                    0 === l && (s = 0),
                                    o.push(O(i))
                                }
                            }(),
                            !a)
                                return T(!0);
                            m = e.options.range,
                            c = d = (f = e.options.loop) ? M(f, "min", -p) : 0,
                            h = u = f ? M(f, "max", p) : s,
                            b = M(m, "min", null),
                            S = M(m, "max", null),
                            null !== b && (d = b),
                            null !== S && (u = S),
                            g = d === -p ? d : e.track.idxToDist(d || 0, !0, 0),
                            v = u === p ? u : w(u, !0, 0),
                            null === S && (h = u),
                            M(m, "align", !1) && u !== p && 0 === n[L(u)][2] && (v -= 1 - n[L(u)][0],
                            u = E(v - y)),
                            g = O(g),
                            v = O(v),
                            Number(t) === t ? I(C(A(t))) : T()
                        },
                        to: F,
                        velocity: function() {
                            var e = x()
                              , t = m.reduce(function(t, i) {
                                var l = i.distance
                                  , r = i.timestamp;
                                return e - r > 200 || (G(l) !== G(t.distance) && t.distance && (t = {
                                    distance: 0,
                                    lastTimestamp: 0,
                                    time: 0
                                }),
                                t.time && (t.distance += l),
                                t.lastTimestamp && (t.time += r - t.lastTimestamp),
                                t.lastTimestamp = r),
                                t
                            }, {
                                distance: 0,
                                lastTimestamp: 0,
                                time: 0
                            });
                            return t.distance / t.time || 0
                        }
                    }
                }(n),
                n.animator = function(e) {
                    var t, i, l, r, n, a;
                    function o(e) {
                        t.active = e
                    }
                    function s(e) {
                        t.targetIdx = e
                    }
                    function d() {
                        var t;
                        t = n,
                        window.cancelAnimationFrame(t),
                        o(!1),
                        s(null),
                        a && e.emit("animationStopped"),
                        a = null
                    }
                    return t = {
                        active: !1,
                        start: function(t) {
                            if (d(),
                            e.track.details) {
                                var u = 0
                                  , c = e.track.details.position;
                                i = 0,
                                l = 0,
                                r = t.map(function(e) {
                                    var t, i = Number(c), r = null !== (t = e.earlyExit) && void 0 !== t ? t : e.duration, n = e.easing, a = e.distance * n(r / e.duration) || 0;
                                    c += a;
                                    var o = l;
                                    return l += r,
                                    u += a,
                                    [i, e.distance, o, l, e.duration, n]
                                }),
                                s(e.track.distToIdx(u)),
                                function t() {
                                    n = window.requestAnimationFrame(function n(d) {
                                        a || (a = d),
                                        o(!0);
                                        var u = d - a;
                                        u > l && (u = l);
                                        var c = r[i];
                                        if (c[3] < u)
                                            return i++,
                                            n(d);
                                        var h = c[2]
                                          , g = c[4]
                                          , v = c[0]
                                          , p = c[1] * (0,
                                        c[5])(0 === g ? 1 : (u - h) / g);
                                        if (p && e.track.to(v + p),
                                        u < l)
                                            return t();
                                        a = null,
                                        o(!1),
                                        s(null),
                                        e.emit("animationEnded")
                                    })
                                }(),
                                e.emit("animationStarted")
                            }
                        },
                        stop: d,
                        targetIdx: null
                    }
                }(n),
                r)
                    for (var e = 0; e < r.length; e++)
                        (0,
                        r[e])(n);
                n.track.init(n.options.initial || 0),
                n.emit("created")
            }(),
            n
        } catch (e) {
            console.error(e)
        }
    };
    let D = /\.(gif|webp|jfif|svg|tiff?)(?:\?|$)/i
      , N = e => D.test(e);
    function q(e, t) {
        let i = B({
            str: e,
            reg: /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
            newString: "."
        });
        if (N(i) || N(i))
            return i;
        let l = B({
            str: i,
            reg: /\.jpg|\.png|\.jpeg/g,
            newString: t,
            isAdd: !0
        });
        return l
    }
    let B = e => {
        var t;
        let i = e.str
          , l = null === (t = e.str.match(e.reg)) || void 0 === t ? void 0 : t.length;
        if (l) {
            let t, r = 1;
            for (; null !== (t = e.reg.exec(e.str)); ) {
                if (r === l) {
                    let l = e.reg.lastIndex
                      , r = l - t[0].length;
                    e.isAdd && (e.newString = "_" + e.newString + t),
                    i = i.slice(0, r) + e.newString + i.slice(l, i.length)
                }
                r++
            }
        }
        return i
    }
      , H = e => {
        let t;
        return t = e ? "string" == typeof e ? new URL(e) : e : new URL(window.location.href),
        RegExp("/collections/", "i").test(t.pathname)
    }
      , W = (e, t, i) => {
        let l = e.getAttribute("gp-data-interaction")
          , r = JSON.parse(l || "{}");
        e.setAttribute("gp-data-interaction", JSON.stringify({
            ...r,
            [t]: i
        }))
    }
    ;
    function U(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i,
        e
    }
    var Y = () => class extends GP.Component {
        connectedCallback() {
            let e = this.closest("gp-product");
            if ((null == e ? void 0 : e.getState) && e.getState("isReady")) {
                this.rootInit();
                return
            }
            null == e || e.addEventListener("gp:product-init", () => {
                requestAnimationFrame( () => {
                    this.context = null == e ? void 0 : e.context,
                    this.rootInit()
                }
                )
            }
            )
        }
        constructor(e) {
            super(),
            U(this, "initFunc", void 0),
            U(this, "rootInit", () => {
                let e = this.closest(".gps > section");
                if (null == e ? void 0 : e.classList.contains("gps-lazy")) {
                    null == e || e.addEventListener("GpLazyLoaded", this.rootInit);
                    return
                }
                null == e || e.removeEventListener("GpLazyLoaded", this.rootInit),
                this.initFunc && this.initFunc()
            }
            ),
            this.initFunc = e
        }
    }
    ;
    (o = v || (v = {})).CONTINUE = "continue",
    o.DENY = "deny",
    (s = p || (p = {})).EXACT = "exact",
    s.ABOVE = "above",
    s.BELOW = "below",
    s.EXACT_OR_ABOVE = "exact_or_above",
    s.EXACT_OR_BELOW = "exact_or_below",
    s.BETWEEN = "between",
    (d = m || (m = {})).INVENTORY_STATUS = "inventory_status",
    d.DISCOUNT_PRICE = "discount_price",
    d.PRICE_RANGE = "price_range",
    d.PRODUCT_TAGS = "product_tags",
    d.CREATION_DATE = "creation_date",
    (u = f || (f = {})).IN_STOCK = "in_stock",
    u.OUT_OF_STOCK = "out_of_stock",
    (c = y || (y = {})).DURATION = "duration",
    c.EXACT_DATE = "exact_date",
    c.BETWEEN_DATES = "between_dates",
    (h = I || (I = {})).PERCENT = "percent",
    h.FIXED = "fixed";
    let j = "variant";
    function X(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i,
        e
    }
    (g = E || (E = {})).Grid = "grid-gallery",
    g.Carousel = "carousel-gallery",
    g.FeatureCarousel = "feature-carousel-gallery";
    var Z = () => class extends Y() {
        setDisplayForImageList(e, t, i) {
            t > 1 ? "only-feature" === i ? e.style.display = "none" : e.style.display = "flex" : "one-col" === i || "two-col" === i ? e.style.display = "flex" : e.style.display = "none"
        }
        setHeightForCustomSize(e) {
            var t;
            let i = window.screenSize.getDeviceName()
              , l = this.getStyles()
              , r = a(l, null == l ? void 0 : l.position)
              , n = null == r ? void 0 : null === (t = r[i]) || void 0 === t ? void 0 : t.shapeLinked;
            n ? e.forEach(e => {
                e.style.height = ""
            }
            ) : e.forEach(e => {
                e.style.height = "100%"
            }
            )
        }
        handleDisplayImagesByVariant() {
            let e = this.getSetting();
            if (!(null == e ? void 0 : e.displayByVariant))
                return;
            let t = this.getSelectedVariantOptionValue();
            if (this.currentFilterValue === t)
                return;
            let i = this.getCurrentLayout();
            this.updateImagesByLayout(i)
        }
        updateImagesByLayout(e) {
            let t = "only-feature" === e
              , i = this.GRID_LAYOUTS.includes(e)
              , l = i ? [E.Grid] : t ? [E.FeatureCarousel] : [E.Carousel, E.FeatureCarousel];
            l.forEach(e => this.handleFilterImagesByVariant(e))
        }
        getCurrentLayout() {
            let e = this.getStyles()
              , t = window.screenSize.getDeviceName();
            return i(e.position, t)
        }
        handleFilterImagesByVariant(e) {
            if (this.initializeGalleryContainers(),
            !this.galleryContainers)
                return;
            let t = this.galleryContainers.get(e);
            t && this.filterImages({
                $container: t,
                type: e
            })
        }
        initializeGalleryContainers() {
            this.$grid && this.$carouselGallery && this.featureImageCarousel || this.setProductImageSelectors(),
            0 === this.galleryContainers.size && (this.galleryContainers.set(E.Grid, this.$grid),
            this.galleryContainers.set(E.Carousel, this.$carouselGallery),
            this.galleryContainers.set(E.FeatureCarousel, this.featureImageCarousel))
        }
        filterImages({$container: e, type: t}) {
            let i = this.getContainerElement(e, t);
            i && (this.cacheInitialGalleryItems(i, t),
            this.currentFilterValue = this.getSelectedVariantOptionValue(),
            this.applyFilter(i, t, this.currentFilterValue),
            t !== E.Grid && this.reinitializeCarousel())
        }
        getContainerElement(e, t) {
            return t === E.Grid ? e : e.querySelector(".gem-slider")
        }
        cacheInitialGalleryItems(e, t) {
            if (this.galleryCache.has(t))
                return;
            let i = Array.from(e.children).map(e => {
                var t, i;
                let l = e.querySelector("img");
                return {
                    element: e,
                    imageAlt: null !== (i = null == l ? void 0 : null === (t = l.alt) || void 0 === t ? void 0 : t.toLowerCase()) && void 0 !== i ? i : ""
                }
            }
            );
            this.galleryCache.set(t, i)
        }
        getSelectedVariantOptionValue() {
            var e, t, i;
            let l = this.getState("setting")
              , r = this.getContext("variantSelected")
              , n = null !== (t = null == r ? void 0 : r.options) && void 0 !== t ? t : []
              , a = n.find(e => e.name === l.variantSelect);
            return null !== (i = null == a ? void 0 : null === (e = a.value) || void 0 === e ? void 0 : e.toLowerCase()) && void 0 !== i ? i : ""
        }
        applyFilter(e, t, i) {
            let l = this.getFilteredImages(i, t);
            this.updateDOM(e, l, t)
        }
        getFilteredImages(e, t) {
            let i = this.galleryCache.get(t);
            if (!(null == i ? void 0 : i.length))
                return [];
            let l = i.filter( ({imageAlt: t}) => this.matchesVariantOption(t, e) || "" === e).map(e => e.element);
            return l.length > 0 ? l : i.map(e => e.element)
        }
        matchesVariantOption(e, t) {
            if (!t)
                return !0;
            if (!e)
                return !1;
            let i = this.normalizeVariantString(e)
              , l = this.normalizeVariantString(t);
            return i.includes(l)
        }
        normalizeVariantString(e) {
            let t = e.trim().toLowerCase();
            return this.VARIANT_SEPARATORS.forEach(e => {
                let i = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                t = t.replace(RegExp(`${i}+`, "g"), "|")
            }
            ),
            t = t.split("|").map(e => e.trim()).filter(Boolean).join("|")
        }
        updateDOM(e, t, i) {
            let l = this.createDocumentFragment(t, i);
            if (this.shouldResetGridImages(l, i)) {
                let i = this.createResetFragment(t);
                this.replaceContainerContent(e, i)
            } else
                this.replaceContainerContent(e, l);
            this.CAROUSEL_GALLERY_TYPES.includes(i) && this.setEventForGalleryImages(),
            i === E.FeatureCarousel && this.initFeaturedImage()
        }
        replaceContainerContent(e, t) {
            e.replaceChildren(t)
        }
        initFeaturedImage() {
            var e;
            this.$featuredImage = null === (e = this.getElementsByClassName("featured-image-only")) || void 0 === e ? void 0 : e[0]
        }
        createDocumentFragment(e, t) {
            let i = document.createDocumentFragment()
              , l = this.galleryCache.get(t) || [];
            return e.forEach( (e, r) => {
                let n = l.find(t => t.element === e);
                if (!n)
                    return;
                let a = this.createClonedWrapper(n, r, t);
                i.appendChild(a)
            }
            ),
            i
        }
        createClonedWrapper(e, t, i) {
            let l = e.element.cloneNode(!0);
            return this.setGridIndex(l, t),
            i === E.Grid && this.setGridDisplayState(l, e.imageAlt),
            l
        }
        setGridIndex(e, t) {
            e.setAttribute("grid-index", (t + 1).toString())
        }
        setGridDisplayState(e, t) {
            let i = this.matchesVariantOption(t, this.currentFilterValue) || !this.currentFilterValue;
            e.style.display = i ? "" : "none"
        }
        shouldResetGridImages(e, t) {
            return t === E.Grid && !this.hasVisibleImages(e)
        }
        hasVisibleImages(e) {
            return Array.from(e.children).some(e => "none" !== e.style.display)
        }
        createResetFragment(e) {
            let t = document.createDocumentFragment()
              , i = this.galleryCache.get(E.Grid) || []
              , l = new Map(i.map(e => [e.element.getAttribute("data-id"), e]));
            return e.forEach(e => {
                let i = e.getAttribute("data-id")
                  , r = l.get(i);
                if (!r)
                    return;
                let n = r.element.cloneNode(!0);
                n.style.display = "",
                t.appendChild(n)
            }
            ),
            t
        }
        reinitializeCarousel() {
            let e = this.getState("id")
              , t = this.getState("product")
              , i = this.querySelector(`#gp-root-carousel-gp-gallery-${e}-${t.id}-${this.sectionId}`);
            (null == i ? void 0 : i.init) && i.init()
        }
        createOrIframe(e, t) {
            var i, l;
            if (null == t ? void 0 : t.featureVideo)
                null == t || t.featureVideo.setAttribute("src", null !== (i = null == t ? void 0 : t.mediaLastSourceURL) && void 0 !== i ? i : "");
            else {
                let i = document.createElement("iframe");
                i.allowFullscreen = !0,
                i.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                i.frameBorder = "0",
                i.setAttribute("class", "feature-video gp-w-full gp-h-full"),
                i.setAttribute("controls", ""),
                i.src = null !== (l = null == t ? void 0 : t.mediaLastSourceURL) && void 0 !== l ? l : "",
                null == e || e.appendChild(i)
            }
        }
        renderExternalVideo(e) {
            let t = document.createElement("iframe");
            return t.allowFullscreen = !0,
            t.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            t.setAttribute("class", "feature-video"),
            Object.assign(t.style, {
                width: "100%",
                height: "100%",
                border: "none",
                "z-index": -1,
                position: "relative"
            }),
            t.setAttribute("controls", "true"),
            t.src = null != e ? e : "",
            t
        }
        pauseAllVideo(e, t) {
            Array.prototype.forEach.call(e, e => {
                var t, i;
                null == e || null === (t = e.contentWindow) || void 0 === t || t.postMessage(JSON.stringify({
                    event: "command",
                    func: "pauseVideo"
                }), "*"),
                null == e || null === (i = e.contentWindow) || void 0 === i || i.postMessage('{"method":"pause"}', "*")
            }
            ),
            Array.prototype.forEach.call(t, e => {
                e.pause()
            }
            )
        }
        playCurrentSlideVideo(e, t) {
            (null == e ? void 0 : e.length) && Array.prototype.forEach.call(e, e => {
                var t, i;
                null == e || null === (t = e.contentWindow) || void 0 === t || t.postMessage(JSON.stringify({
                    event: "command",
                    func: "playVideo"
                }), "*"),
                null == e || null === (i = e.contentWindow) || void 0 === i || i.postMessage('{"method":"play"}', "*")
            }
            ),
            (null == t ? void 0 : t.length) && Array.prototype.forEach.call(t, e => {
                e.play()
            }
            )
        }
        isHidden(e) {
            let t = window.getComputedStyle(e);
            return "none" === t.display
        }
        constructor() {
            super( () => {
                var e;
                this.productFormID = null === (e = this.closest("gp-product form")) || void 0 === e ? void 0 : e.getAttribute("id");
                let t = this.getSetting();
                this.enableActiveEffect = !!(null == t ? void 0 : t.borderActive),
                this.setProductImageSelectors(),
                window.addEventListener(`activeMoveIndexSlider-${this.productFormID}`, () => {
                    setTimeout( () => {
                        this.handleFirstActiveVariant()
                    }
                    , 0)
                }
                , {
                    once: !0
                }),
                this.handleFirstActiveVariant(),
                this.handleChangeVariant(),
                this.init(),
                this.onListenerInteraction(),
                this.onListenerChangeSlideInteraction(),
                this.handleDisplayImagesByVariant()
            }
            ),
            X(this, "currentDevice", "desktop"),
            X(this, "featureImageHeightGlobal", 0),
            X(this, "timeout", null),
            X(this, "currentActiveImageID", "0"),
            X(this, "isChangedVariant", !1),
            X(this, "enableActiveEffect", !0),
            X(this, "$featuredImage", void 0),
            X(this, "$gpProductImagesGallery", void 0),
            X(this, "$grid", void 0),
            X(this, "$carouselGallery", void 0),
            X(this, "featureImageCarousel", void 0),
            X(this, "productFormID", void 0),
            X(this, "sectionId", void 0),
            X(this, "defaultIndexFeatureImage", void 0),
            X(this, "currentFilterValue", null),
            X(this, "galleryCache", new Map),
            X(this, "galleryContainers", new Map),
            X(this, "VARIANT_SEPARATORS", ["-", "_", "&", " ", "+", "/"]),
            X(this, "SELECTOR_FOR_IMAGE_ITEM", ".gp-image-item"),
            X(this, "SELECTOR_FOR_GALLERY_IMAGE_GRID", ".gp-product-images-gallery .grid-gallery"),
            X(this, "SELECTOR_FOR_GALLERY_IMAGE_ITEM", ".gp-gallery-image-item"),
            X(this, "SELECTOR_FOR_GALLERY_GRID_IMAGE_ITEM", ".grid-gallery .gp-gallery-image-item"),
            X(this, "FEATURE_IMAGE_WRAPPER_CLASS", ".gp-featured-image-wrapper"),
            X(this, "GRID_LAYOUTS", ["one-col", "two-col"]),
            X(this, "CAROUSEL_GALLERY_TYPES", [E.Carousel, E.FeatureCarousel]),
            X(this, "init", async () => {
                if (this.sectionId = this.getAttribute("section-id"),
                this.handleMouseOnFeatureImage(),
                this.handleMouseOnGalleryGridItem(),
                this.currentDevice = window.screenSize.getDeviceName(),
                this.handleWindowResize(),
                this.setEventForGalleryImages(),
                this.handleFeaturedImageWrapper(),
                this.setEventForFeatureImages(),
                this.setEventForFeatureImageCarousel(),
                this.$featuredImage) {
                    let e = new ResizeObserver( () => {
                        this.setHeightForProductGallery(),
                        this.setHeightForFeatureImageCarousel(),
                        this.setHeightForImageWrapper(),
                        this.setPositionForGallery()
                    }
                    );
                    e.observe(this.$featuredImage, {})
                }
                let e = this.querySelector(this.SELECTOR_FOR_GALLERY_IMAGE_GRID);
                if (e) {
                    let t = e.querySelectorAll(this.SELECTOR_FOR_GALLERY_IMAGE_ITEM)
                      , i = new ResizeObserver( () => {
                        let e = this.isOnlyImageListLayout();
                        t.length && t.forEach(t => {
                            if (e) {
                                let e = t.getAttribute("data-outline") || "active"
                                  , i = t.getAttribute("data-outline-backup");
                                i || t.setAttribute("data-outline-backup", e),
                                t.setAttribute("data-outline", "active")
                            } else {
                                let e = t.getAttribute("data-outline-backup");
                                e && (t.setAttribute("data-outline", e),
                                t.removeAttribute("data-outline-backup"))
                            }
                        }
                        )
                    }
                    );
                    i.observe(e, {})
                }
            }
            ),
            X(this, "setProductImageSelectors", () => {
                var e, t, i, l, r;
                this.$featuredImage = null === (e = this.getElementsByClassName("featured-image-only")) || void 0 === e ? void 0 : e[0],
                this.$gpProductImagesGallery = null === (t = this.getElementsByClassName("gp-product-images-gallery")) || void 0 === t ? void 0 : t[0],
                this.$grid = null === (i = this.getElementsByClassName("grid-gallery")) || void 0 === i ? void 0 : i[0],
                this.$carouselGallery = null === (l = this.getElementsByClassName("carousel-gallery")) || void 0 === l ? void 0 : l[0],
                this.featureImageCarousel = null === (r = this.getElementsByClassName("gp-feature-image-carousel")) || void 0 === r ? void 0 : r[0]
            }
            ),
            X(this, "updateDataHiddenForInteraction", (e, t) => {
                e && e.querySelectorAll("gp-product-badge").forEach(e => {
                    let i = window.getComputedStyle(e).display;
                    "none" === i ? e.setAttribute("gp-data-hidden", null != t ? t : "true") : e.setAttribute("gp-data-hidden", null != t ? t : "false")
                }
                )
            }
            ),
            X(this, "displayProductBadgeByLayout", () => {
                let e = this.getStyles()
                  , t = this.getSetting()
                  , l = window.screenSize.getDeviceName()
                  , r = i(e.position, l)
                  , n = i(t.type, l)
                  , a = this.querySelectorAll('[type="gp-feature-image-carousel"]')
                  , o = this.querySelectorAll('[type="grid-gallery"]');
                a.forEach(e => {
                    let t = window.getComputedStyle(e).display;
                    this.updateDataHiddenForInteraction(e, "none" === t ? "true" : void 0)
                }
                ),
                o.forEach(e => {
                    let t = window.getComputedStyle(e).display;
                    ["bottom-left", "bottom-center", "inside-bottom"].includes(r) && "images" === n && (t = "none"),
                    this.updateDataHiddenForInteraction(e, "none" === t ? "true" : void 0)
                }
                )
            }
            ),
            X(this, "displayGalleryImagesByLayout", () => {
                let e = this.getStyles()
                  , t = window.screenSize.getDeviceName()
                  , l = i(e.position, t);
                if (this.displayProductBadgeByLayout(),
                this.$gpProductImagesGallery) {
                    var r;
                    let e = null === (r = this.$gpProductImagesGallery.getElementsByClassName("grid-gallery")) || void 0 === r ? void 0 : r[0]
                      , t = this.$gpProductImagesGallery.getElementsByClassName("gp-image-item").length;
                    if (e) {
                        let e = t / 2;
                        this.setDisplayForImageList(this.$gpProductImagesGallery, e, l)
                    } else {
                        if (this.$grid) {
                            let e = this.$grid.getElementsByClassName("gp-image-item").length;
                            e <= 1 && (["one-col", "two-col"].includes(l) ? this.$grid.style.display = "flex" : this.$grid.style.display = "none")
                        }
                        this.setDisplayForImageList(this.$gpProductImagesGallery, t, l)
                    }
                }
            }
            ),
            X(this, "getStyles", () => {
                let e = this.getState("styles");
                return e
            }
            ),
            X(this, "getSetting", () => {
                let e = this.getState("setting");
                return e
            }
            ),
            X(this, "getPositionByDevice", e => {
                let t = this.getStyles();
                return i(null == t ? void 0 : t.position, e)
            }
            ),
            X(this, "getCarouselLayout", () => {
                let e = this.getStyles()
                  , t = {};
                return n.forEach(i => {
                    var l, r;
                    let n = this.getPositionByDevice(i);
                    t = "right" == n || "left" == n ? {
                        ...t,
                        [i]: null == e ? void 0 : null === (l = e.verticalLayoutRow) || void 0 === l ? void 0 : l[i]
                    } : {
                        ...t,
                        [i]: null == e ? void 0 : null === (r = e.verticalLayout) || void 0 === r ? void 0 : r[i]
                    }
                }
                ),
                t
            }
            ),
            X(this, "getWidthForGallery", () => {
                let e = this.getStyles()
                  , t = null == e ? void 0 : e.fullWidth
                  , i = null == e ? void 0 : e.width;
                return n.forEach(l => {
                    var r, n, a, o, s;
                    let d = null == e ? void 0 : null === (r = e.position) || void 0 === r ? void 0 : r[l]
                      , u = (null === (n = t) || void 0 === n ? void 0 : n[l]) === void 0 ? null === (a = t) || void 0 === a ? void 0 : a.desktop : null === (o = t) || void 0 === o ? void 0 : o[l];
                    t = {
                        ...t,
                        [l]: u
                    },
                    "bottom-left" === d || "bottom-center" === d || (t = {
                        ...t,
                        [l]: !1
                    },
                    i = {
                        ...i,
                        [l]: u ? "100%" : null == e ? void 0 : null === (s = e.width) || void 0 === s ? void 0 : s[l]
                    })
                }
                ),
                {
                    ...l("w", r(i, t)),
                    ...l("maxw", r(i, t))
                }
            }
            ),
            X(this, "getStyleOfObject", e => {
                let t = Object.keys(e)
                  , i = "";
                return t.forEach(t => {
                    i += `${t}: ${e[t]};`
                }
                ),
                i
            }
            ),
            X(this, "setPositionForGallery", () => {
                var e, t, i, l, r, n, a, o, s, d, u, c;
                if (!this.$gpProductImagesGallery)
                    return;
                let h = window.screenSize.getDeviceName()
                  , g = this.$gpProductImagesGallery.querySelectorAll(".gp-gallery-image-item > div");
                if (this.setHeightForCustomSize(g),
                this.$grid) {
                    let r = this.$grid.querySelectorAll(".gp-gallery-image-item img");
                    this.setHeightForCustomSize(r);
                    let n = null === (t = this.getPositionForGallery()) || void 0 === t ? void 0 : null === (e = t.left) || void 0 === e ? void 0 : e[h];
                    n ? this.$grid.style.left = n : this.$grid.style.left = "";
                    let a = null === (l = this.getPositionForGallery()) || void 0 === l ? void 0 : null === (i = l.bottom) || void 0 === i ? void 0 : i[h];
                    a ? this.$gpProductImagesGallery.style.bottom = a : this.$gpProductImagesGallery.style.bottom = ""
                }
                if (this.$gpProductImagesGallery) {
                    let e = null === (n = this.getPositionForGallery()) || void 0 === n ? void 0 : null === (r = n.left) || void 0 === r ? void 0 : r[h];
                    e ? this.$gpProductImagesGallery.style.left = e : this.$gpProductImagesGallery.style.left = "";
                    let t = null === (o = this.getPositionForGallery()) || void 0 === o ? void 0 : null === (a = o.right) || void 0 === a ? void 0 : a[h];
                    t ? this.$gpProductImagesGallery.style.right = t : this.$gpProductImagesGallery.style.right = "";
                    let i = null === (d = this.getPositionForGallery()) || void 0 === d ? void 0 : null === (s = d.bottom) || void 0 === s ? void 0 : s[h];
                    i ? this.$gpProductImagesGallery.style.bottom = i : this.$gpProductImagesGallery.style.bottom = "";
                    let l = null === (c = this.getPositionForGallery()) || void 0 === c ? void 0 : null === (u = c.top) || void 0 === u ? void 0 : u[h];
                    l ? this.$gpProductImagesGallery.style.top = l : this.$gpProductImagesGallery.style.top = ""
                }
            }
            ),
            X(this, "setHeightForProductGallery", () => {
                let e = window.screenSize.getDeviceName();
                if (this.$gpProductImagesGallery) {
                    let t = this.getHeightForGallery()[e] || 0;
                    t ? this.$gpProductImagesGallery.style.height = t : this.$gpProductImagesGallery.style.height = ""
                }
            }
            ),
            X(this, "getHeightForImageCarousel", () => {
                var e;
                let t = window.screenSize.getDeviceName()
                  , i = this.getHeightForGallery()[t]
                  , l = (isNaN(Number(i)) ? null === (e = this.$featuredImage) || void 0 === e ? void 0 : e.clientHeight : i) + "px";
                return l
            }
            ),
            X(this, "setHeightForFeatureImageCarousel", () => {
                var e;
                let t = null === (e = this.featureImageCarousel) || void 0 === e ? void 0 : e.getElementsByClassName("gem-slider-item")
                  , i = this.getHeightForImageCarousel();
                for (let e = 0; e < (null == t ? void 0 : t.length); e++) {
                    let l = null == t ? void 0 : t.item(e);
                    l && (l.style.height = i)
                }
            }
            ),
            X(this, "setHeightForImageWrapper", () => {
                var e;
                let t = null === (e = this.featureImageCarousel) || void 0 === e ? void 0 : e.getElementsByClassName("image-carousel-wrapper")
                  , i = this.getHeightForImageCarousel();
                for (let e = 0; e < (null == t ? void 0 : t.length); e++) {
                    let l = null == t ? void 0 : t.item(e);
                    l && (l.style.height = i)
                }
            }
            ),
            X(this, "getPositionForGallery", () => {
                let e = {}
                  , t = {}
                  , l = {}
                  , r = {}
                  , a = this.getStyles();
                return n.forEach(n => {
                    let o = i(null == a ? void 0 : a.position, n)
                      , s = i(null == a ? void 0 : a.spacing, n);
                    ["inside-left", "inside-bottom"].includes(o) && (e = {
                        ...e,
                        [n]: `${s}`
                    }),
                    ["inside-right"].includes(o) && (t = {
                        ...t,
                        [n]: `${s}`
                    }),
                    ["inside-bottom"].includes(o) && (l = {
                        ...l,
                        [n]: `${s}`
                    }),
                    ["inside-left", "inside-right"].includes(o) && (r = {
                        ...r,
                        [n]: `${s}`
                    })
                }
                ),
                {
                    left: e,
                    right: t,
                    bottom: l,
                    top: r
                }
            }
            ),
            X(this, "getHeightForGallery", () => {
                let e = {}
                  , t = this.getStyles();
                return n.forEach(l => {
                    var r;
                    let n = i(null == t ? void 0 : t.position, l)
                      , a = ["left", "right"].includes(n)
                      , o = ["inside-left", "inside-right"].includes(n)
                      , s = i(null == t ? void 0 : t.spacing, l)
                      , d = (null === (r = this.$featuredImage) || void 0 === r ? void 0 : r.clientHeight) || 300
                      , u = parseInt(s)
                      , c = u ? `${d - 2 * u}px` : `calc(${d}px - ${s} * 2)`;
                    e = {
                        ...e,
                        [l]: a ? d + "px" : o ? c : "fit-content"
                    }
                }
                ),
                e
            }
            ),
            X(this, "handleFirstActiveVariant", () => {
                var e, t, i, l;
                let r;
                let n = this.getContext("variantSelected")
                  , a = this.getState("setting")
                  , o = this.getState("product")
                  , s = 0;
                if ((null == a ? void 0 : a.typeDisplay) === "all-images" && (null == o ? void 0 : null === (e = o.media) || void 0 === e ? void 0 : e.length) > 0)
                    switch (null == a ? void 0 : a.preDisplay) {
                    case "1st-images":
                        r = o.media[0],
                        s = 0;
                        break;
                    case "1st-3d-mode":
                        r = o.media.find( (e, t) => {
                            if ("model" === e.media_type)
                                return s = t,
                                !0
                        }
                        );
                        break;
                    case "1st-video":
                        r = o.media.find( (e, t) => {
                            if (["video", "external_video"].includes(e.media_type))
                                return s = t,
                                !0
                        }
                        );
                        break;
                    case "1st-available-variant":
                        s = (null === (t = r = this.getActiveImage(null == n ? void 0 : n.featured_image)) || void 0 === t ? void 0 : t.index) || 0
                    }
                else
                    s = (null === (i = r = this.getActiveImage(null == n ? void 0 : n.featured_image)) || void 0 === i ? void 0 : i.index) || 0;
                r && (r.index = (null === (l = r) || void 0 === l ? void 0 : l.index) || s || 0,
                this.handleChangeFeaturedImage(r),
                this.handleActiveImagesWhenChangeVariant("grid-gallery", r),
                this.handleActiveImagesWhenChangeVariant("carousel-gallery", r))
            }
            ),
            X(this, "handleChangeVariant", () => {
                this.subscribeContext( (e, t) => {
                    var i, l, r, n, a;
                    if ((null == e ? void 0 : null === (i = e.variantSelected) || void 0 === i ? void 0 : i.id) === (null == t ? void 0 : null === (l = t.variantSelected) || void 0 === l ? void 0 : l.id))
                        return;
                    this.isChangedVariant = !0;
                    let o = null === (r = e.variantSelected) || void 0 === r ? void 0 : r.featured_image;
                    this.handleChangeFeaturedImageOnly(null === (a = e.variantSelected) || void 0 === a ? void 0 : null === (n = a.featured_image) || void 0 === n ? void 0 : n.src);
                    let s = this.getActiveImage(o);
                    s && (this.handleChangeFeaturedImage(s),
                    this.handleActiveImagesWhenChangeVariant("grid-gallery", s),
                    this.handleActiveImagesWhenChangeVariant("carousel-gallery", s)),
                    this.handleDisplayImagesByVariant()
                }
                )
            }
            ),
            X(this, "handleActiveImagesWhenChangeVariant", (e, t) => {
                let i = "grid-gallery" === e ? this.$grid : this.$carouselGallery;
                if (!i || this.isHidden(i))
                    return;
                let l = i.querySelectorAll(this.SELECTOR_FOR_IMAGE_ITEM);
                this.handleActiveImage(l[t.index]);
                let r = this.getState("id")
                  , n = this.getState("product")
                  , a = this.querySelector(`#gp-root-carousel-gp-gallery-${r}-${n.id}`);
                a && !this.isHidden(a) && (null == a ? void 0 : a.moveToIdx) && (null == a || a.moveToIdx(t.index))
            }
            ),
            X(this, "getActiveImage", e => {
                var t, i;
                let l = this.$grid || this.$carouselGallery || this.featureImageCarousel;
                if (!l)
                    return;
                let r = l.querySelectorAll(this.SELECTOR_FOR_IMAGE_ITEM)
                  , n = null == e ? void 0 : e.id
                  , a = -1;
                if (r.forEach( (e, t) => {
                    var i;
                    let l = null === (i = e.id.toString().split("-").slice(-1)) || void 0 === i ? void 0 : i[0];
                    n && n.toString() === l && (a = t)
                }
                ),
                a >= 0) {
                    let l = null === (t = r[a]) || void 0 === t ? void 0 : t.querySelector("img")
                      , n = null == l ? void 0 : null === (i = l.dataset) || void 0 === i ? void 0 : i.src;
                    return {
                        src: (null == e ? void 0 : e.src) || n || (null == l ? void 0 : l.src),
                        id: l.id,
                        width: l.width,
                        height: l.height,
                        alt: l.alt,
                        index: a
                    }
                }
            }
            ),
            X(this, "handleFeaturedImageWrapper", () => {
                var e;
                let t = this.getSetting()
                  , l = this.getState("product")
                  , r = this.getState("productUrl")
                  , n = (null == l ? void 0 : l.handle) ? function(...e) {
                    let t = Array.from(Array.isArray(e[0]) ? e[0] : e);
                    return function(e) {
                        let t = [];
                        if (0 === e.length)
                            return "";
                        if ("string" != typeof e[0])
                            throw TypeError("Url must be a string. Received " + e[0]);
                        e[0].match(/^[^/:]+:\/*$/) && e.length > 1 && (e[0] = e.shift() + e[0]),
                        e[0].match(/^file:\/\/\//) ? e[0] = e[0].replace(/^([^/:]+):\/*/, "$1:///") : e[0] = e[0].replace(/^([^/:]+):\/*/, "$1://");
                        for (let i = 0; i < e.length; i++) {
                            let l = e[i];
                            if ("string" != typeof l)
                                throw TypeError("Url must be a string. Received " + l);
                            "" !== l && (i > 0 && (l = l.replace(/^\/+/, "")),
                            l = i < e.length - 1 ? l.replace(/\/+$/, "") : l.replace(/\/+$/, "/"),
                            t.push(l))
                        }
                        let i = t.join("/");
                        i = i.replace(/\/(\?|&|#[^!])/g, "$1");
                        let l = i.split("?");
                        return l.shift() + (l.length > 0 ? "?" : "") + l.join("&")
                    }(t)
                }("/products", l.handle) : "#"
                  , a = (null == t ? void 0 : t.clickEffect) !== void 0 && (null == t ? void 0 : t.clickEffect) == "link";
                if (a) {
                    let e = this.featureImageCarousel;
                    e.href = null != r ? r : n
                } else {
                    if (!(null == t ? void 0 : t.ftClickOpenLightBox))
                        return;
                    let r = window.screenSize.getDeviceName()
                      , n = i(null == t ? void 0 : t.ftClickOpenLightBox, r);
                    if (!n)
                        return;
                    let a = null === (e = this.featureImageCarousel) || void 0 === e ? void 0 : e.querySelectorAll(".gp-ft-image-item");
                    null == a || a.forEach(e => {
                        let t = null == e ? void 0 : e.getAttribute("data-event-click");
                        t || (e.setAttribute("data-event-click", "true"),
                        e.addEventListener("click", () => {
                            var t, i, r;
                            let n = this.querySelectorAll(this.SELECTOR_FOR_IMAGE_ITEM)
                              , a = e.querySelector("img")
                              , o = e.querySelector(".feature-video")
                              , s = e.querySelector("model-viewer");
                            if (s || o) {
                                let e = s ? null == s ? void 0 : s.getAttribute("src") : null == o ? void 0 : o.getAttribute("src")
                                  , i = null === (t = l.media.find(t => {
                                    var i;
                                    return null == t ? void 0 : null === (i = t.sources) || void 0 === i ? void 0 : i.find(t => (null == t ? void 0 : t.url) == e)
                                }
                                )) || void 0 === t ? void 0 : t.position;
                                i || n.forEach(t => {
                                    let l = s ? t.getAttribute("media-source-url") : t.getAttribute("media-last-source-url");
                                    l == e && (i = parseInt(t.getAttribute("grid-index") || "0"))
                                }
                                );
                                let r = {
                                    src: e,
                                    width: parseInt(null == s ? void 0 : s.getAttribute("width")),
                                    height: parseInt(null == s ? void 0 : s.getAttribute("height")),
                                    index: i && i >= 1 ? i - 1 : i || 0
                                };
                                this.handleClickImage(r, this.getSetting().ftClickOpenLightBox, !1)
                            }
                            if (a) {
                                let e = null == a ? void 0 : null === (i = a.dataset) || void 0 === i ? void 0 : i.src
                                  , t = null == a ? void 0 : null === (r = a.src) || void 0 === r ? void 0 : r.replace("_1024x1024", "")
                                  , n = null == l ? void 0 : l.media.findIndex(e => "image" === e.media_type && t.includes(null == e ? void 0 : e.src.trim()))
                                  , o = {
                                    src: e || a.src,
                                    id: a.id,
                                    width: a.width,
                                    height: a.height,
                                    alt: a.alt,
                                    index: n
                                };
                                this.handleClickImage(o, this.getSetting().ftClickOpenLightBox, !1)
                            }
                        }
                        ))
                    }
                    )
                }
            }
            ),
            X(this, "isExistModel3DInGallery", () => {
                let e = this.getState("product")
                  , t = e.media.find(e => "model" === e.media_type);
                return !!t
            }
            ),
            X(this, "handleMouseOnFeatureImage", () => {
                var e, t, i;
                let l = null === (e = this.featureImageCarousel) || void 0 === e ? void 0 : e.querySelectorAll(this.SELECTOR_FOR_IMAGE_ITEM);
                if (!(null == l ? void 0 : l.length))
                    return;
                let r = this.getSetting()
                  , n = this.getState("product")
                  , a = (null !== (i = null == n ? void 0 : null === (t = n.media) || void 0 === t ? void 0 : t.length) && void 0 !== i ? i : 0) === 1
                  , o = (r.otherImage || 0) > (null == l ? void 0 : l.length) - 1 ? (null == l ? void 0 : l.length) - 1 : r.otherImage;
                null == l || l.forEach(e => {
                    null == e || e.addEventListener("mousemove", t => {
                        let i = e.querySelector("model-viewer");
                        i && t.stopPropagation();
                        let l = this.querySelector(this.FEATURE_IMAGE_WRAPPER_CLASS);
                        this.handleMouseMove(t, l, {
                            hoverEffect: r.hoverEffect,
                            zoom: r.zoom,
                            zoomType: r.zoomType,
                            otherImage: a ? 1 : o
                        })
                    }
                    ),
                    null == e || e.addEventListener("mouseout", e => {
                        this.handleMouseOut(e)
                    }
                    )
                }
                )
            }
            ),
            X(this, "handleMouseOnGalleryGridItem", () => {
                let e = this.querySelectorAll(this.SELECTOR_FOR_GALLERY_GRID_IMAGE_ITEM);
                if (this.getSetting().galleryHoverEffect && "none" != this.getSetting().galleryHoverEffect) {
                    let t = this.getSetting();
                    e.forEach(e => {
                        null == e || e.addEventListener("mousemove", e => {
                            e.stopPropagation();
                            let i = e.currentTarget;
                            this.handleMouseMove(e, i, {
                                hoverEffect: t.galleryHoverEffect,
                                zoom: t.galleryZoom,
                                zoomType: t.galleryZoomType
                            })
                        }
                        ),
                        null == e || e.addEventListener("mouseout", e => {
                            e.stopPropagation(),
                            this.handleMouseOut(e)
                        }
                        )
                    }
                    )
                }
            }
            ),
            X(this, "displayZoomImage", ({event: e, featureImageDom: t, zoomSize: i, zoomSizeHeight: l, imagePosition: r, slideWidth: n, imageOffsetX: a, imageOffsetY: o, $zoomElement: s, $zoomLens: d, setting: u, isEnableShowOtherImage: c=!1}) => {
                if (s) {
                    if (s.style.width = `${i}px`,
                    c ? s.style.height = "100%" : s.style.height = `${l}px`,
                    e.clientX >= (null == r ? void 0 : r.x) && e.clientX <= r.right && e.clientY >= (null == r ? void 0 : r.y) && e.clientY <= r.bottom ? (((null == u ? void 0 : u.hoverEffect) == "zoom" && (null == u ? void 0 : u.zoomType) == "default" || (null == u ? void 0 : u.hoverEffect) == "other") && (s.style.opacity = "1",
                    s.style.zIndex = "1"),
                    d && (null == u ? void 0 : u.hoverEffect) == "zoom" && (null == u ? void 0 : u.zoomType) == "glasses" && (d.style.opacity = "1",
                    d.style.zIndex = "1")) : (s.style.opacity = "0",
                    s.style.zIndex = "-1",
                    d && (d.style.opacity = "0"),
                    d && (d.style.zIndex = "-1")),
                    n && (null == u ? void 0 : u.hoverEffect) == "zoom" && (null == u ? void 0 : u.zoomType) == "default") {
                        let e = a / (null == t ? void 0 : t.offsetWidth)
                          , l = o / (null == t ? void 0 : t.offsetHeight);
                        s.style.top = ((null == t ? void 0 : t.offsetHeight) - s.offsetHeight) * l + "px",
                        s.style.left = (n - i) * e + "px"
                    }
                    (null == u ? void 0 : u.hoverEffect) == "other" && (s.style.top = "0px",
                    s.style.left = "0px")
                }
            }
            ),
            X(this, "handleMouseMove", (e, i, l) => {
                var r, n, a, o, s, d;
                let u = null === (r = e.currentTarget) || void 0 === r ? void 0 : r.querySelector("img")
                  , c = null == u ? void 0 : u.getBoundingClientRect()
                  , h = null === (a = e.currentTarget) || void 0 === a ? void 0 : null === (n = a.getElementsByClassName("zoom-element")) || void 0 === n ? void 0 : n[0]
                  , g = null === (s = e.currentTarget) || void 0 === s ? void 0 : null === (o = s.getElementsByClassName("zoom-lens-element")) || void 0 === o ? void 0 : o[0]
                  , v = this.getSetting()
                  , p = this.getState("product");
                if ("other" === v.hoverEffect && 1 === p.media.length) {
                    let e = h.querySelector("img");
                    null == e || e.setAttribute("srcSet", null === (d = p.media[0]) || void 0 === d ? void 0 : d.src)
                }
                let m = (null == i ? void 0 : i.clientWidth) || 0
                  , f = (null == i ? void 0 : i.clientHeight) || 0
                  , y = (null == l ? void 0 : l.hoverEffect) == "other"
                  , I = t(null == l ? void 0 : l.zoom, 0)
                  , E = !I || I < 100 ? 1 : I / 100 || 1
                  , b = (m || 1) * ((null == l ? void 0 : l.hoverEffect) == "other" ? 1 : E)
                  , S = (f || 1) * ((null == l ? void 0 : l.hoverEffect) == "other" ? 1 : E)
                  , w = e.clientX - (null == c ? void 0 : c.x)
                  , C = e.clientY - (null == c ? void 0 : c.y);
                if ((I && I > 100 || (null == l ? void 0 : l.hoverEffect) === "other") && this.displayZoomImage({
                    event: e,
                    featureImageDom: u,
                    zoomSize: b,
                    zoomSizeHeight: S,
                    imagePosition: c,
                    slideWidth: m,
                    imageOffsetX: w,
                    imageOffsetY: C,
                    $zoomElement: h,
                    $zoomLens: g,
                    setting: l,
                    isEnableShowOtherImage: y
                }),
                (null == l ? void 0 : l.hoverEffect) == "zoom" && (null == l ? void 0 : l.zoomType) == "glasses" && g) {
                    let e = g.offsetWidth / 2
                      , t = g.offsetHeight / 2
                      , i = f || 1;
                    w > m - e / E && (w = m - e / E),
                    w < e / E && (w = e / E),
                    C > i - t / E && (C = i - t / E),
                    C < t / E && (C = t / E),
                    g.style.top = C - t + "px",
                    g.style.left = w - e + "px",
                    g.style.backgroundSize = b + "px " + i * E + "px",
                    g.style.backgroundPosition = `-${w * E - e}px -${C * E - t}px`
                }
            }
            ),
            X(this, "getLayoutByCurrentScreen", () => i(this.getStyles().position, window.screenSize.getDeviceName())),
            X(this, "isOnlyImageListLayout", () => !1),
            X(this, "handleMouseOut", e => {
                var t, i, l, r;
                let n = null === (i = e.currentTarget) || void 0 === i ? void 0 : null === (t = i.getElementsByClassName("zoom-element")) || void 0 === t ? void 0 : t[0]
                  , a = null === (r = e.currentTarget) || void 0 === r ? void 0 : null === (l = r.getElementsByClassName("zoom-lens-element")) || void 0 === l ? void 0 : l[0];
                n && (n.style.opacity = "0",
                n.style.zIndex = "-1"),
                a && (a.style.opacity = "0",
                a.style.zIndex = "-1")
            }
            ),
            X(this, "handleActiveImage", (e, t) => {
                (!this.isOnlyImageListLayout() || !t) && e && this.enableActiveEffect && (this.removeActiveStatusForAllImageItem(),
                this.addActiveStatusForImageItem(e))
            }
            ),
            X(this, "removeActiveStatusForAllImageItem", () => {
                let e = this.querySelectorAll(this.SELECTOR_FOR_IMAGE_ITEM);
                e.forEach(e => {
                    e.setAttribute("data-outline", "deactive")
                }
                )
            }
            ),
            X(this, "addActiveStatusForImageItem", e => {
                this.isOnlyImageListLayout() ? e.setAttribute("data-outline-backup", "active") : e.setAttribute("data-outline", "active"),
                this.currentActiveImageID = e.getAttribute("id") || ""
            }
            ),
            X(this, "setEventForFeatureImageCarousel", () => {
                let e = this.querySelector("gp-carousel.gp-feature-image-carousel");
                e && (null == e || e.addEventListener("changeActiveIndex", this.handleActiveImageWhenFeatureImageNextSlide))
            }
            ),
            X(this, "handleActiveImageWhenFeatureImageNextSlide", () => {
                var e, t, i;
                let l = this.querySelector("gp-carousel.gp-feature-image-carousel");
                if (!l)
                    return;
                let r = parseInt(l.getAttribute("active-index") || "0")
                  , n = this.getState("product")
                  , a = n.media[r];
                if (!a)
                    return;
                let o = this.getLayoutByCurrentScreen();
                if ("two-col" === o && this.$carouselGallery) {
                    null === (e = this.$carouselGallery.querySelector('[data-outline="active"]')) || void 0 === e || e.setAttribute("data-outline", "deactive"),
                    null === (t = this.$carouselGallery.querySelector(`[grid-index="${r + 1}"]`)) || void 0 === t || t.setAttribute("data-outline", "active");
                    return
                }
                let s = {
                    id: a.id,
                    index: r,
                    width: 1024,
                    height: 1024,
                    src: null !== (i = a.src) && void 0 !== i ? i : a.preview_image.src
                };
                this.currentActiveImageID = a.id,
                this.handleActiveImagesWhenChangeVariant("grid-gallery", s),
                this.handleActiveImagesWhenChangeVariant("carousel-gallery", s)
            }
            ),
            X(this, "setEventForGalleryImages", () => {
                var e, t;
                let i = e => {
                    e.forEach( (e, t) => {
                        let i = e.querySelector("img");
                        i && (null == e || e.addEventListener("click", () => {
                            var l, r, n;
                            let a = null == i ? void 0 : null === (l = i.dataset) || void 0 === l ? void 0 : l.src
                              , o = null == i ? void 0 : null === (r = i.dataset) || void 0 === r ? void 0 : r.contenttype
                              , s = null == i ? void 0 : null === (n = i.dataset) || void 0 === n ? void 0 : n.code
                              , d = {
                                src: a || i.src,
                                id: i.id,
                                width: i.width,
                                height: i.height,
                                alt: i.alt,
                                index: t,
                                contentType: o,
                                code: s
                            };
                            this.handleActiveImage(e, !0),
                            this.handleClickImage(d, this.getSetting().clickOpenLightBox)
                        }
                        ))
                    }
                    )
                }
                  , l = null === (e = this.$grid) || void 0 === e ? void 0 : e.querySelectorAll(this.SELECTOR_FOR_GALLERY_IMAGE_ITEM);
                l && i(l);
                let r = null === (t = this.$carouselGallery) || void 0 === t ? void 0 : t.querySelectorAll(this.SELECTOR_FOR_GALLERY_IMAGE_ITEM);
                r && i(r)
            }
            ),
            X(this, "setEventForFeatureImages", () => {
                let e = this.querySelectorAll(".gp-ft-image-item");
                e.forEach( (e, t) => {
                    let i = e.querySelector("img")
                      , l = null == e ? void 0 : e.getAttribute("data-event-click");
                    i && !l && (null == e || e.setAttribute("data-event-click", "true"),
                    null == e || e.addEventListener("click", () => {
                        var e, l, r;
                        let n = null == i ? void 0 : null === (e = i.dataset) || void 0 === e ? void 0 : e.src
                          , a = null == i ? void 0 : null === (l = i.dataset) || void 0 === l ? void 0 : l.contenttype
                          , o = null == i ? void 0 : null === (r = i.dataset) || void 0 === r ? void 0 : r.code
                          , s = {
                            src: n || i.src,
                            id: i.id,
                            width: i.width,
                            height: i.height,
                            alt: i.alt,
                            index: t,
                            contentType: a,
                            code: o
                        };
                        this.handleClickImage(s, this.getSetting().ftClickOpenLightBox, !1)
                    }
                    ))
                }
                )
            }
            ),
            X(this, "renderModal3d", (e, t) => {
                let i = document.createElement("model-viewer");
                return i.setAttribute("class", "model-viewer gp-z-10"),
                i.setAttribute("src", null != e ? e : ""),
                i.setAttribute("poster", null != t ? t : ""),
                i.setAttribute("camera-controls", "true"),
                i.setAttribute("data-js-focus-visible", "true"),
                i.setAttribute("data-shopify-feature", "true"),
                i.setAttribute("ar-status", "not-presenting"),
                Object.assign(i.style, {
                    width: "100%",
                    height: "100%"
                }),
                i
            }
            ),
            X(this, "renderVideo", (e, t) => {
                let i = document.createElement("video");
                return i.setAttribute("class", "feature-video"),
                i.setAttribute("src", null != e ? e : ""),
                i.setAttribute("poster", null != t ? t : ""),
                i.setAttribute("controls", "true"),
                Object.assign(i.style, {
                    width: "calc(100% - 2px)",
                    "max-height": "100%"
                }),
                i
            }
            ),
            X(this, "handleOpenModal", e => {
                let t = document.getElementById("gp-modal-product-image");
                t && t.remove(),
                this.createModelViewImages(e)
            }
            ),
            X(this, "renderImageItems", e => {
                let t = "";
                return e.forEach(e => {
                    t += `<div class="gem-slider-item" style="height: 100%;"><img style="width: 100%; height: 100%; object-fit: contain;
      object-position: center; top: 0; left: 0" src="${e}" /></div>`
                }
                ),
                t
            }
            ),
            X(this, "sliderTemplate", e => `<div class="gem-slider-item" style="height: 100%; text-align: center; padding-left: 2px; padding-right: 2px; display: flex; align-items: center">
              ${e}
          </div>`),
            X(this, "renderMediaItem", e => {
                let t = this.$grid || this.$carouselGallery
                  , i = "";
                return e.forEach(e => {
                    var l, r, n, a, o, s;
                    if ("model" === e.media_type) {
                        let t = this.makeMediaSource(e.sources, !0);
                        i += this.sliderTemplate(null === (l = this.renderModal3d(null == t ? void 0 : t.url, null == e ? void 0 : null === (r = e.preview_image) || void 0 === r ? void 0 : r.src)) || void 0 === l ? void 0 : l.outerHTML)
                    } else if ("video" === e.media_type) {
                        let t = this.makeMediaSource(e.sources, !1);
                        i += this.sliderTemplate(null === (n = this.renderVideo(null == t ? void 0 : t.url, null == e ? void 0 : null === (a = e.preview_image) || void 0 === a ? void 0 : a.src)) || void 0 === n ? void 0 : n.outerHTML)
                    } else if ("external_video" === e.media_type) {
                        let l = this.makeMediaSource(e.sources, !1)
                          , r = null == l ? void 0 : l.url;
                        l || (r = (null == t ? void 0 : null === (s = t.querySelector(`[external-id="${e.external_id}"]`)) || void 0 === s ? void 0 : s.getAttribute("media-last-source-url")) || ""),
                        i += this.sliderTemplate(null === (o = this.renderExternalVideo(r)) || void 0 === o ? void 0 : o.outerHTML)
                    } else if ("image" === e.media_type) {
                        let t = q(null == e ? void 0 : e.src, "3000x3000");
                        i += this.sliderTemplate(`<img style="width: 100%; height: 100%; object-fit: contain;
            object-position: center; top: 0; left: 0" src="${t}" />`)
                    }
                }
                ),
                i
            }
            ),
            X(this, "makeMediaSource", (e, t) => {
                if (!e)
                    return;
                if (t)
                    return e.find(e => "glb" === e.format);
                let i = e.find(e => "mp4" === e.format && 1080 === e.height);
                return i || e.find(e => "mp4" === e.format)
            }
            ),
            X(this, "navigationStyle", `
      <style>
        .navigation-wrapper {
          position: relative;
          width: 100%;
          height: 80vh;
        }
        .dots {
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: -17px;
          left: 50%;
          transform: translateX(-50%);
        }

        .dot {
          border: none;
          width: 12px;
          height: 12px;
          background: #E2E2E2;
          border-radius: 50%;
          margin: 0 4px;
          padding: 6px;
          cursor: pointer;
          display: block !important;
        }

        .dot:focus {
          outline: none;
        }

        .dot--active {
          background: #121212;
        }

        .arrow {
          width: 24px;
          height: 24px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          cursor: pointer;
          display: block;
        }

        .arrow--left {
          left: 4px;
          background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' fill='%236B7280' viewBox='0 0 24 24' %3E%3Cpath d='M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z' %3E%3C/path%3E%3C/svg%3E");
        }

        .arrow--right {
          left: auto;
          right: 4px;
          background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' fill='%236B7280'  viewBox='0 0 24 24' %3E%3Cpath d='M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z'%3E%3C/path%3E%3C/svg%3E");
        }

        @media (max-width: 992px) {
          .gp-modal-product-image-wrapper {
            width: 100% !important;
          }

          .navigation-wrapper {
            height: 60vh !important;
          }

          .arrow {
            width: 24px;
            height: 24px;
          }

          .arrow--right {
            left: auto;
            right: -20px;
          }

          .arrow--left {
            right: auto;
            left: -20px;
          }
        }
      </style>
    `),
            X(this, "createModelViewImages", async e => {
                var t, i, l;
                let r = this.getState("product")
                  , n = document.createElement("div");
                n.id = "gp-modal-product-image",
                n.style.cssText = `
        width: 100%;
        height: 100vh;
        position: fixed;
        background-color: transparent;
        top: 0;
        left: 0;
        z-index: 9999;
      `;
                let a = this.renderMediaItem(r.media)
                  , o = `
        ${this.navigationStyle}
        <div style="width: 100%; height: 100%; position: relative; padding: 0 16px;
        display: flex; align-items: center; justify-content: center">
          <div id="gp-modal-product-image-overlay" style="background-color: rgb(0 0 0 / 0.6); width: 100%; height: 100%; position: absolute; z-index: 0; display: block !important"></div>
          <div class="gp-modal-product-image-wrapper" style="width: 80%; background-color: #fff; border-radius: 3px; padding: 24px; overflow: hidden; z-index: 1; position: relative;">
            <div id="gp-close-product-popup" style="width: 20px; height: 20px; display: flex; position: absolute; top: 16px; right: 16px; z-index: 2; cursor: pointer">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.1758 12.0241C11.4101 12.2584 11.79 12.2584 12.0243 12.0241C12.2586 11.7898 12.2586 11.4099 12.0243 11.1755L8.84858 7.9998L12.0243 4.82407C12.2586 4.58975 12.2586 4.20986 12.0243 3.97554C11.79 3.74123 11.4101 3.74123 11.1758 3.97554L8.00005 7.15128L4.82431 3.97554C4.59 3.74123 4.2101 3.74123 3.97578 3.97554C3.74147 4.20986 3.74147 4.58975 3.97578 4.82407L7.15152 7.9998L3.97579 11.1755C3.74147 11.4099 3.74147 11.7898 3.97579 12.0241C4.2101 12.2584 4.59 12.2584 4.82431 12.0241L8.00005 8.84833L11.1758 12.0241Z" fill="#676767"/>
              </svg>

            </div>
            <div id="gp-keen-slider" style="width: 100%; height: 100%; display: flex; position: relative; overflow: hidden;">
              ${a}
            </div>
            <div></div>
          </div>
        </div>
        `;
                n.innerHTML = o,
                null === (t = document.querySelector("body")) || void 0 === t || t.appendChild(n);
                let s = new V("#gp-keen-slider",{
                    selector: ".gem-slider-item",
                    loop: !1,
                    vertical: !1,
                    slides: {
                        origin: "center",
                        perView: 1
                    }
                },[this.sliderNavigation]);
                e && e.index > -1 && s.moveToIdx(null == e ? void 0 : e.index),
                null === (i = n.querySelector("#gp-modal-product-image-overlay")) || void 0 === i || i.addEventListener("click", () => {
                    n.remove()
                }
                ),
                null === (l = n.querySelector("#gp-close-product-popup")) || void 0 === l || l.addEventListener("click", () => {
                    n.remove()
                }
                )
            }
            ),
            X(this, "sliderNavigation", e => {
                let t, i, l, r;
                let n = e.slides.length < 2;
                function a(a) {
                    (function(i) {
                        if (i) {
                            let e = t.parentNode;
                            for (; t.firstChild; )
                                null == e || e.insertBefore(t.firstChild, t);
                            o(t);
                            return
                        }
                        t = s("navigation-wrapper"),
                        e.container.parentNode.appendChild(t),
                        t.appendChild(e.container)
                    }
                    )(a),
                    n || (function(l) {
                        if (l) {
                            o(i);
                            return
                        }
                        i = s("dots"),
                        e.track.details.slides.forEach( (t, l) => {
                            let r = s("dot");
                            r.addEventListener("click", () => e.moveToIdx(l)),
                            i.appendChild(r)
                        }
                        ),
                        t.appendChild(i)
                    }(a),
                    function(i) {
                        if (i) {
                            o(l),
                            o(r);
                            return
                        }
                        (l = s("arrow arrow--left")).addEventListener("click", () => e.prev()),
                        (r = s("arrow arrow--right")).addEventListener("click", () => e.next()),
                        t.appendChild(l),
                        t.appendChild(r)
                    }(a))
                }
                function o(e) {
                    var t;
                    null == e || null === (t = e.parentNode) || void 0 === t || t.removeChild(e)
                }
                function s(e) {
                    let t = document.createElement("div")
                      , i = e.split(" ");
                    return i.forEach(e => t.classList.add(e)),
                    t
                }
                function d() {
                    var t, a, o;
                    if (n)
                        return;
                    let s = e.track.details.rel
                      , d = e.options.loop;
                    l.style.display = 0 !== s || d ? "block" : "none",
                    r.style.display = s !== (null == e ? void 0 : null === (o = e.track) || void 0 === o ? void 0 : null === (a = o.details) || void 0 === a ? void 0 : null === (t = a.slides) || void 0 === t ? void 0 : t.length) - 1 || d ? "block" : "none",
                    Array.from(i.children).forEach(function(e, t) {
                        t === s ? e.classList.add("dot--active") : e.classList.remove("dot--active")
                    })
                }
                e.on("created", () => {
                    a(),
                    d()
                }
                ),
                e.on("optionsChanged", () => {
                    a(!0),
                    a(),
                    d()
                }
                ),
                e.on("slideChanged", () => {
                    let i = t.querySelectorAll("iframe")
                      , l = t.querySelectorAll("video");
                    this.pauseAllVideo(i, l),
                    d();
                    let r = e.track.details.rel
                      , n = e.slides[r]
                      , a = n.querySelectorAll("iframe")
                      , o = n.querySelectorAll("video");
                    this.playCurrentSlideVideo(a, o)
                }
                ),
                e.on("destroyed", () => {
                    a(!0)
                }
                )
            }
            ),
            X(this, "handleClickImage", (e, t, l=!0) => {
                let r = i(t, this.currentDevice);
                if ("product-link" === r) {
                    this.navigateToProductPage();
                    return
                }
                (!0 === r || "popup" === r) && this.handleOpenModal(e);
                let n = this.querySelector(".modal-wrapper")
                  , a = null == n ? void 0 : n.querySelector("gp-carousel");
                e && a && (null == a || a.moveToIdx(e.index || 0)),
                l && !this.isOnlyImageListLayout() && (this.handleChangeFeaturedImageOnly(e.src),
                this.handleChangeFeaturedImage(e))
            }
            ),
            X(this, "resizeImageByQuery", (e, t, i=2) => {
                let l = /\?.+=.+/.test(e);
                return l ? `${e}&width=${t * i}` : `${e}?width=${t}`
            }
            ),
            X(this, "handleChangeFeaturedImageOnly", e => {
                let t = this.querySelectorAll(".gp-feature-image-only img");
                t.length && e && t.forEach(t => {
                    let i = t.clientWidth
                      , l = this.resizeImageByQuery(e, i);
                    t.setAttribute("src", l),
                    t.setAttribute("srcSet", l)
                }
                )
            }
            ),
            X(this, "getProductUrl", (e=!1) => {
                var t, i, l, r, n;
                let {product: a, collection: o, productUrl: s, collectionUrl: d, pageContext: u} = this.getState()
                  , c = `/products/${a.handle}`
                  , h = null !== (n = null === (r = window) || void 0 === r ? void 0 : null === (l = r.Shopify) || void 0 === l ? void 0 : null === (i = l.routes) || void 0 === i ? void 0 : null === (t = i.root) || void 0 === t ? void 0 : t.replace(/\/+$/, "")) && void 0 !== n ? n : "";
                if (e && o && d && (null == u ? void 0 : u.hasCollectionHandle)) {
                    let e = null != d ? d : `/collections/${o.handle}`
                      , t = d.startsWith(`${h}/`)
                      , i = t ? "" : h;
                    return `${i}${e}${c}`
                }
                let g = null == s ? void 0 : s.startsWith(`${h}/`)
                  , v = g ? "" : h;
                return `${v}${null != s ? s : c}`
            }
            ),
            X(this, "navigateToProductPage", () => {
                let e = this.getProductUrl(H())
                  , t = this.getContext("variantSelected")
                  , i = this.isChangedVariant ? this.updateUrlWithVariant(e, t) : e
                  , l = this.getSetting().ftClickOpenNewTab;
                l ? window.open(i, "_blank") : window.location.href = i
            }
            ),
            X(this, "updateUrlWithVariant", (e, t) => {
                let i = new URL(e,window.location.origin);
                return (null == t ? void 0 : t.id) ? i.searchParams.set(j, t.id.toString()) : i.searchParams.delete(j),
                i.toString()
            }
            ),
            X(this, "handleChangeFeaturedImage", e => setTimeout( () => {
                let t = this.closest("gp-product")
                  , i = null == t ? void 0 : t.querySelectorAll("gp-carousel.gp-feature-image-carousel");
                i && i.length && i.forEach(t => {
                    let i = t.querySelectorAll("iframe")
                      , l = t.querySelectorAll("video");
                    this.pauseAllVideo(i, l),
                    t.moveToIdx(e.index || 0);
                    let r = e.index;
                    t.setAttribute("active-index", r.toString());
                    let n = t.querySelectorAll(".gem-slider-item")[r]
                      , a = null == n ? void 0 : n.querySelectorAll("iframe")
                      , o = null == n ? void 0 : n.querySelectorAll("video");
                    setTimeout( () => {
                        this.playCurrentSlideVideo(a, o)
                    }
                    , 1e3)
                }
                )
            }
            , 0)),
            X(this, "handleChangeZoomLensImage", e => {
                let t = this.querySelector(".zoom-lens-element");
                t && (t.style.backgroundImage = "url(" + q(e.src, "1024x1024") + ")")
            }
            ),
            X(this, "handleWindowResize", () => {
                this.displayGalleryImagesByLayout(),
                window.addEventListener("resize", () => {
                    this.displayGalleryImagesByLayout(),
                    this.currentDevice = window.screenSize.getDeviceName()
                }
                , !0)
            }
            ),
            X(this, "slideMoveToIndex", e => {
                let t = this.querySelector("gp-carousel.gp-feature-image-carousel");
                t && (null == t ? void 0 : t.moveToIdx) && (null == t || t.moveToIdx(e))
            }
            ),
            X(this, "nextSlide", e => {
                let {key: t, data: i, isRollback: l} = e
                  , r = this.querySelector("gp-carousel.gp-feature-image-carousel");
                r && (null == r || r.nextSlide({
                    key: t,
                    data: i,
                    isRollback: l,
                    element: this
                }))
            }
            ),
            X(this, "previousSlide", e => {
                let {key: t, data: i, isRollback: l} = e
                  , r = this.querySelector("gp-carousel.gp-feature-image-carousel");
                r && (null == r || r.previousSlide({
                    key: t,
                    data: i,
                    isRollback: l,
                    element: this
                }))
            }
            ),
            X(this, "getCurrentFeaturedImageIndex", () => {
                let e = this.querySelector("gp-carousel.gp-feature-image-carousel")
                  , t = parseInt((null == e ? void 0 : e.getAttribute("active-index")) || "0");
                return t
            }
            ),
            X(this, "onListenerInteraction", () => {
                this.onTrigger && this.onTrigger({
                    event: "gp:change-image-step"
                }, e => {
                    let {data: t, isRollback: i, uniqueStorageKey: l} = e || {};
                    void 0 === this.defaultIndexFeatureImage && (this.defaultIndexFeatureImage = this.getCurrentFeaturedImageIndex()),
                    i || W(this, l, this.defaultIndexFeatureImage.toString()),
                    this.slideMoveToIndex(Number(t))
                }
                )
            }
            ),
            X(this, "onListenerChangeSlideInteraction", () => {
                this.onTrigger && (this.onTrigger({
                    event: "gp:change-previous-slide"
                }, e => {
                    let {isRollback: t, uniqueStorageKey: i, data: l} = e || {};
                    this.previousSlide({
                        key: i,
                        data: l,
                        isRollback: t
                    })
                }
                ),
                this.onTrigger({
                    event: "gp:change-next-slide"
                }, e => {
                    let {isRollback: t, uniqueStorageKey: i, data: l} = e || {};
                    this.nextSlide({
                        key: i,
                        data: l,
                        isRollback: t
                    })
                }
                ))
            }
            )
        }
    }
    ;
    let J = () => {
        window.removeEventListener("gp-global-loaded", J),
        customElements.get("gp-product-images") || customElements.define("gp-product-images", Z())
    }
    ;
    "completed" === window.gpReadyState ? J() : window.addEventListener("gp-global-loaded", J),
    e.defineComponentProductImageV2 = J
}({});
